import { type Viewer } from '@xeokit/xeokit-sdk';

export const useViewerBCFViewpointsStore = defineStore('viewer-bcf-viewpoints-store', () => {
  const { $BCFViewpointsPlugin } = useNuxtApp();
  const viewerStore = useViewerStore();

  const isInitialized = ref(false);

  let plugin: InstanceType<typeof $BCFViewpointsPlugin> | undefined;

  function getPlugin() {
    return plugin;
  }

  function init() {
    const viewer = viewerStore.getHelpers().viewer as Viewer;
    if (!viewer) return;

    plugin = new $BCFViewpointsPlugin(viewer);

    isInitialized.value = true;
  }

  return {
    isInitialized,
    getPlugin,
    init,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useViewerBCFViewpointsStore, import.meta.hot));
}
